import { SagaIterator } from 'redux-saga';
import { signInData, signInError, SignInGoogleFetch } from '../actions';
import { call, put } from 'redux-saga/effects';
import api from '../../../../api-new/http';
import { appUrls } from '../../../../api-new/urls';
import { userData } from '../../profile';
import { sendError } from '../../../public/errorHandler';

export function* signInGoogleSaga(action: SignInGoogleFetch): SagaIterator {
    try {
        const response = yield call(() => api.post(`${appUrls.authenURL}/login-google`, {}, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${action.payload.accessToken}`,
            },
        }));
        const { accessToken, refreshToken } = response.data.data;
        localStorage.setItem('csrfToken', accessToken);
        localStorage.setItem('themeCode', refreshToken);
        const responseProfile = yield call(() => api.get(`${appUrls.authenURL}/profile`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
        }));
        yield put(userData({ user: responseProfile.data.data }));

        (window as any).umami?.track('login', { method: 'google', email: responseProfile.data.data.email });

        yield put(signInData());
    } catch (error: any) {
        const errorSetup = {
            message: error.response.data.errors[0].errorMessage,
            code: error.response.status,
            codeConfig: error.response.data.errors[0].errorCode,
        };
        yield put(
            sendError({
                error: errorSetup,
                processingType: 'alert',
                extraOptions: {
                    actionError: signInError,
                },
            }),
        );
    }
}

